import React, { Component } from "react";
import { connect } from 'react-redux';
import { Thumbnail } from "react-bootstrap";
import { authOperations, authSelectors } from './state';
import { Redirect, withRouter } from "react-router-dom";
import { ORDER } from "../../containers/BPOrder/routes";
import LoginForm from "./LoginForm";
import ChangePassword from "./ChangePassword";
import { ADMIN } from "../../../utils/constants";
import '../../../includes/custom/css/login.css';
import { ORDER_LIST } from "../MobileOrders/routes";
import moment from 'moment-timezone';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tel: "xxx-xxx-xxxx",
      email: "xxxxx@xxxx.xxx.xxxx",
      owner: "事業者名"
    };
    this.props.history.push({state: { 
      changePassword: this.props.history.location.state && this.props.history.location.state.changePassword }})
  }

  componentDidMount = () => {
    this.props.initialize()
      .then((result) => {
        let details = result.data
        if (null !== details){
          this.props.setTimezoneOffset(details.timezone_id);
          moment.tz.setDefault(details.timezone_id);

          this.setState({
            owner: details.owner,
            tel: details.tel,
            email: details.email
          })
        }
      })
  }

  toggleLogin = () => {
    this.props.history.push({state: { changePassword: !this.props.history.location.state.changePassword }})    
  }

  render() {
    if (authSelectors.isAuthenticated()) {

      return ADMIN === this.props.user.authorities.authority ?
        (
          <Redirect to={ORDER} />
        ) : (
          <Redirect to={ORDER_LIST} />
        )

    } else {
      this.props.logoutUser();
      let mailTo = "mailto:" + this.state.email
        + "?Subject=【ことねぎオーダーシステム】"
        + "問い合わせ"

      return (
        <div className="body">
          <footer className="loginFooter">
              {this.state.owner}<br />
              電話番号 {this.state.tel}<br />
              メールでのお問い合わせは
            <a href={mailTo} className="mailLink">こちら</a><br />
            </footer>
          <center className="middle">
            <Thumbnail className="loginCard clearfix">
              {this.props.history.location.state.changePassword ?
                <ChangePassword toggleLogin = {this.toggleLogin.bind(this)} />
                : <LoginForm toggleLogin = {this.toggleLogin.bind(this)} />}
            </Thumbnail>
          </center>
        </div>
      );

    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.credentials
  }
};

const mapDispatchToProps = {
  loginUser: authOperations.loginUser,
  logoutUser: authOperations.logoutUser,
  initialize: authOperations.initialize,
  setTimezoneOffset: authOperations.setTimezoneOffset
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));